import { StepButton, StepContent, StepLabel, Stepper, StepperOwnProps } from '@mui/material';
import React, { ReactNode } from 'react';
import { isNotNullOrUndefined } from '@vy/utils';
import { StyledConnector, StyledStep, StyledStepLabel } from './styled-components';
import { StepperStepIcon } from './StepperStepIcon';

type BasicStepItem = {
  label: string;
  stepIndex: number;
};

export type VyStepFields<StepItem = BasicStepItem> = StepItem & { isDisabled: boolean; isCompleted: boolean };

type VyStepperProps<StepItem = BasicStepItem> = {
  activeStep?: number;
  nonLinear?: boolean;
  steps: VyStepFields<StepItem>[];
  onStepClick?: (step: VyStepFields<StepItem>) => void;
  renderStepLabel: (step: VyStepFields<StepItem>, index: number, array: VyStepFields<StepItem>[]) => string;
  keyExtractor: (step: VyStepFields<StepItem>) => React.Key;
  renderStepContent?: (
    step: VyStepFields<StepItem>,
    index: number,
    array: VyStepFields<StepItem>[],
  ) => ReactNode;
  orientation?: StepperOwnProps['orientation'];
};

export const VyStepper = <StepItem,>({
  activeStep,
  steps,
  onStepClick: handleStepClick,
  renderStepLabel,
  renderStepContent,
  keyExtractor,
  orientation,
  nonLinear = true,
}: VyStepperProps<StepItem>) => {
  return (
    <Stepper
      nonLinear={nonLinear}
      activeStep={activeStep}
      connector={<StyledConnector />}
      orientation={isNotNullOrUndefined(renderStepContent) ? 'vertical' : orientation}
    >
      {steps.map((step, index, array) => {
        const key = keyExtractor(step);

        return (
          <StyledStep key={key} disabled={step.isDisabled} completed={step.isCompleted}>
            <StepButton onClick={() => handleStepClick?.(step)}>
              <StepLabel
                slots={{
                  stepIcon: StepperStepIcon,
                }}
              >
                <StyledStepLabel>{renderStepLabel(step, index, array)}</StyledStepLabel>
              </StepLabel>
            </StepButton>

            {renderStepContent && <StepContent>{renderStepContent(step, index, array)}</StepContent>}
          </StyledStep>
        );
      })}
    </Stepper>
  );
};
